import ReactMarkdown from 'react-markdown';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import rehypeRaw from 'rehype-raw';
import rehypePrismPlus from 'rehype-prism-plus';

import React from "react";
import './styles/content-styles.css';
import './styles/prism-theme.css';
import './styles/codeblock.css';
interface ICkOutputProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  data: React.ReactNode;
}
function CkOutput({ data, className }: ICkOutputProps) {
  return (
    <div className={`ck-content ${className ?? ''}`}>
      <ReactMarkdown
        children={data as string}
        remarkPlugins={[remarkMath]}
        rehypePlugins={[rehypeRaw, rehypeKatex, rehypePrismPlus]}
      />
    </div>
  );
}
export { CkOutput };
